export default "__VITE_ASSET__C5e57KU7__"